"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = getImgObjFromDom;

var _isNeededImg = _interopRequireDefault(require("./isNeededImg"));

var _getImgSrcFromBgImg = _interopRequireDefault(require("./getImgSrcFromBgImg"));

/**
 * @file 提取dom节点中的图片（img元素或者背景图片）
 * @author zhangyanting
 */

/**
 * 提取图片链接
 * @param {Object} dom dom对象
 * @public
 */
function getImgObjFromDom(dom) {
  var visibleHeight = document.documentElement.clientHeight;
  var domTopOnScreen = dom && dom.getBoundingClientRect().top;

  if (!(domTopOnScreen && domTopOnScreen >= 0 && domTopOnScreen < visibleHeight)) {
    return false;
  }

  var src = '';
  var needImg = {
    domContainer: null,
    src: ''
  };

  if (dom.nodeName.toUpperCase() === 'IMG') {
    // img标签
    var imgSrc = dom.getAttribute('src') || dom.getAttribute('data-src');
    needImg = {
      domContainer: dom,
      src: imgSrc
    };
  } else {
    // 作为元素背景图的情况
    var computedStyle = window.getComputedStyle(dom);
    var bgImgValue = computedStyle.getPropertyValue('background-image');
    var bgValue = computedStyle.getPropertyValue('background');
    var bgImg = bgImgValue || bgValue;

    if (!bgImg) {
      return '';
    }

    var tempSrc = (0, _getImgSrcFromBgImg.default)(bgImg);
    needImg = {
      domContainer: dom,
      src: tempSrc
    };
  }

  if ((0, _isNeededImg.default)(needImg)) {
    src = needImg.src;
  }

  return needImg;
}